import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Menu from '../menu/Menu';
import RTButton from '../common/RTButton';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import UnassignedComplaints from './UnassignedComplaints';
import AssignedComplaints from './AssignedComplaints';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ComplaintManagement.css';

const ViewOpenComplaints = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('unassigned');

  const handleTabSelect = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="rt-layout">
      <Menu className="rt-menu" activePath={location.pathname} />
      <div className="rt-main-content">
        <div className="rt-title-row">
          <h2 className="rt-title">Open Complaints</h2>
          <div className="rt-actions">
            <RTButton variant="secondary" onClick={() => navigate(-1)}>
              ← Back
            </RTButton>
          </div>
        </div>
        
        <div className="rt-main-section">
          <Tabs
            activeKey={activeTab}
            onSelect={handleTabSelect}
            id="complaints-tabs"
            className="rt-fullwidth-tabs"
            justify
          >
            <Tab 
              eventKey="unassigned" 
              title="Unassigned" 
              style={{ minHeight: '60%', border: '0.5px solid #e0e0e0' }}
            >
              <UnassignedComplaints loadData={activeTab === 'unassigned'} />
            </Tab>
            <Tab 
              eventKey="assigned" 
              title="Assigned" 
              style={{ minHeight: '60%', border: '0.5px solid #e0e0e0' }}
            >
              <AssignedComplaints loadData={activeTab === 'assigned'} />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default ViewOpenComplaints;
